export default __webpack_public_path__ + "static/media/searchNewIcon.5dbdfc4e.svg";